import React from "react";
import { Form, Input, message } from "antd";
import { Auth } from "aws-amplify"; // Import Amplify Auth
import { LOGGER } from "../../../helpers/logger";
import { confirmResetPassword } from "aws-amplify/auth";
import { passwordValidator } from "../../../helpers/passwordPolicy";
import { GET_LOCAL_STORAGE } from "../../../helpers/localStorage";
import { showError } from "../../../helpers/alerts";

function ConfirmPassword({ nextPage }) {
  // Function to handle the confirmation of password reset
  async function handleConfirmResetPassword({ confirmationCode, newPassword }) {
    try {
      await confirmResetPassword({
        username: GET_LOCAL_STORAGE("email"),
        confirmationCode,
        newPassword,
      });
      LOGGER("Password reset successful");
      nextPage(); // Proceed to the next page or redirect the user
      localStorage.removeItem("email");
    } catch (error) {
      showError(error.message);
      LOGGER(error);
    }
  }

  const onFinish = (values) => {
    LOGGER("val:", values);
    handleConfirmResetPassword(values);
  };

  const onFinishFailed = (errorInfo) => {
    LOGGER("Failed:", errorInfo);
  };

  return (
    <>
      <h1 className="mb-3 font-medium text-[16px]">Create a New Password</h1>
      <Form
        name="basic"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="confirmationCode"
          label={
            <p className="text-[14px] text-[#626476]">Verification Code</p>
          }
          rules={[
            {
              required: true,
              message: "Please enter the verification code!",
            },
          ]}
        >
          <Input
            autoComplete="off"
            className="py-[10px] px-[10px]"
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label={<p className="text-[14px] text-[#626476]">New Password</p>}
          rules={[{ validator: passwordValidator("new") }]}
          hasFeedback
        >
          <Input.Password
            autoComplete="new-password"
            className="py-[10px] px-[10px]"
          />
        </Form.Item>
        <Form.Item
          name="confirm"
          label={<p className="text-[14px] text-[#626476]">Confirm Password</p>}
          dependencies={["newPassword"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Please confirm your password!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The new password that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password
            autoComplete="new-password"
            className="py-[10px] px-[10px]"
          />
        </Form.Item>
        <button
          type="submit"
          className="w-[100%] rounded-[5px] text-[13px] font-medium text-white py-[10px] bg-[#005EB8]"
        >
          Submit
        </button>
      </Form>
    </>
  );
}

export default ConfirmPassword;
